/* istanbul ignore file */
import React from 'react';
import { useParams } from 'react-router-dom';
import ServiceBreadcrumbs from 'domain/organization/service/shared/ServiceBreadcrumbs';
import { SingleBreadcrumbItem } from 'framework/ui/BreadCrumbs';
import { BreadcrumbsProps } from 'framework/ui/BreadCrumbs';
import { useServiceUrl } from 'domain/shared/service';

const SingleServiceBreadcrumbs = ({ children }: BreadcrumbsProps) => {
  const { getSingleEntityUrl } = useServiceUrl();
  const { id } = useParams<Dictionary<string>>();

  return (
    <ServiceBreadcrumbs>
      <SingleBreadcrumbItem entity={id!} link={getSingleEntityUrl(id)} />
      {children}
    </ServiceBreadcrumbs>
  );
};

export default SingleServiceBreadcrumbs;
